// Campus photo for /colleges/suny-college-of-environmental-science-and-forestry: CC BY-SA 4.0, by Kiran891, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AGateway_Center%2C_SUNY_ESF.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/suny-college-of-environmental-science-and-forestry/; credited under the photo.
const photo = {
    "slug": "suny-college-of-environmental-science-and-forestry",
    "alt": "The Gateway Center, with its tall timber columns and glass front, on the SUNY College of Environmental Science and Forestry campus in Syracuse, New York",
    "src": "/colleges/suny-college-of-environmental-science-and-forestry/campus-1600.webp",
    "srcSmall": "/colleges/suny-college-of-environmental-science-and-forestry/campus-800.webp",
    "srcMid": "/colleges/suny-college-of-environmental-science-and-forestry/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/suny-college-of-environmental-science-and-forestry/og.jpg",
    "title": "Gateway Center, SUNY ESF",
    "author": "Kiran891",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AGateway_Center%2C_SUNY_ESF.jpg",
    "read": "2026-10-01"
};

export default photo;
